<form [formGroup]="mutationForm" (ngSubmit)="submitForm()" class="flex justify-center">
  <mat-card class="flex flex-col">
    <p id="etablissement">
      Etablissement actuel {{ displayActual(currentClient) }}
    </p>
    <mat-form-field floatLabel="always">
      <input formControlName="clientFilter" placeholder="Nouveau client de l'utilisateur" type="text" matInput
        [matAutocomplete]="clients">
      <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
    </mat-form-field>
    <mat-autocomplete #clients='matAutocomplete' [displayWith]="displayFn" (optionSelected)="updateClient($event)"
      (closed)="displaySelected()">
      <mat-option></mat-option>
      <mat-option *ngFor="let client of listOfClients | async" [value]="client">
        {{ displayFn(client) }}
      </mat-option>
    </mat-autocomplete>
    <mat-form-field>
      <textarea formControlName="comment" matInput placeholder="Commentaire"></textarea>
    </mat-form-field>
    <mat-error *ngIf="mutationForm.hasError('required')">Vous devez choisir un nouveau client ou mettre un
      commentaire.</mat-error>
    <mat-form-field>
      <input matInput placeholder="Nouveau N° de Casier" formControlName="newCasier">
    </mat-form-field>
    <mat-card-actions>
      <button mat-raised-button type="submit">Enregistrer</button>
    </mat-card-actions>
  </mat-card>
</form>